<!-- ================管理端-个人备课====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">个人备课列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建个人备课</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.title" placeholder="请输入备课名称">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="状态" prop="status">
                    <template #default="scope">
                        <div>{{ formatStatus(scope.row.status) }}</div>
                    </template>
                </el-table-column>
                <el-table-column min-width="220" align="center" label="备课名称" prop="lessonName">
                    <template #default="scope">
                        <div :title="scope.row.lessonName" @click="goDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="center" label="学段·年级·学科">
                    <template #default="scope">
                        <el-text>
                            {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="创建时间" prop="createTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="120" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="goDetail(scope.row)">查看</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status!==9">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status!==9">
                                            <el-text type="primary" @click="handleRelease(scope.row)">完成备课</el-text>
                                        </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                            confirm-button-text="是"
                                            cancel-button-text="否"
                                            icon-color="#626AEF"
                                            title="确定删除该备课?"
                                            @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page="queryParams.pageNum"
                        v-model:limit="queryParams.pageSize"
                        @pagination="getList" />
        </div>
    </div>

</template>
<script>
import { lessonPageLessons, delLesson,lessonEnd } from "@/api/admin/lesson";
import { timestampToTime } from "@/utils/date";

export default {
    components: {},
    name: "selfLessonIndex",
    data() {
        return {
            timestampToTime,
            loading: false,
            total: 0,
            dataList: [],
            queryParams: {
                title: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type:1,
                pageNum: 1,
                pageSize: 10,
            },
            statusList: [
                { name: '初始', value: 1 },
                { name: '备课完成', value: 9 },
            ],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getList();
    },
    mounted() {},
    methods: {
        formatStatus(status) {
            const item = this.statusList.find(s => s.value === status);
            return item ? item.name : status;
        },
        /** 查询备课列表 */
        getList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            lessonPageLessons(this.queryParams).then(res => {
                if (res.data && res.data.code == 1) {
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置查询条件 */
        resetQuery() {
            this.queryParams = {
                title: '',
                type:1,
                pageNum: 1,
                pageSize: 10,
            };
            this.getList();
        },
        handleRelease(row) {
            lessonEnd({ lessonId: row.lessonId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.getList();
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        /** 创建备课 */
        handleCreate() {
            this.$router.push({
                path: "/selfLessonCreate",
            });
        },
        /** 编辑备课 */
        handleUpdate(row) {
            this.$router.push({
                path: "/selfLessonCreate",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 备课详情 */
        goDetail(row) {
            this.$router.push({
                path: "/selfLessonDetail",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 删除备课 */
        handleDelete(row) {
            delLesson({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "删除失败");
                }
            })
        },
    },
}
</script>
<style scoped>
.name-search-btn {
    background-color: #377f7f !important;
    color: #fff !important;
}
</style>
